/**
 * TODO: This is a temporary util for formatting date-time labels.
 * Migrate to a robust solution or shared date library once finalised.
 */
export const formatDateTimeLabel = (
	input: string | Date,
	locale?: Intl.LocalesArgument,
): string => {
	if (!input) return '';

	const date = input instanceof Date ? input : new Date(input);
	if (Number.isNaN(date.getTime())) return '';

	const dateFormatter = new Intl.DateTimeFormat(locale, {
		weekday: 'short',
		day: 'numeric',
		month: 'short',
	});

	const timeFormatter = new Intl.DateTimeFormat(locale, {
		hour: 'numeric',
		minute: '2-digit',
		hour12: true,
	});

	return `${dateFormatter.format(date)} • ${timeFormatter.format(date)}`;
};
